module.exports = __webpack_public_path__ + "img/bonaire,-sint-eustatius-and-saba.8376be1c.svg";